import { render, staticRenderFns } from "./XUpImg.vue?vue&type=template&id=5dbf91ba&scoped=true"
import script from "./XUpImg.vue?vue&type=script&lang=js"
export * from "./XUpImg.vue?vue&type=script&lang=js"
import style0 from "./XUpImg.vue?vue&type=style&index=0&id=5dbf91ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf91ba",
  null
  
)

export default component.exports